import Vue from 'vue'
import { getUrlAllParams } from '@/app/core/utils'
const BETA = process.env.VUE_APP_SEVERENV === 'BETA'
if (process.env.NODE_ENV === 'production') {
  import('@sentry/browser').then(Sentry => {
    import('@sentry/integrations').then((integrations: any) => {
      const VueIntegration = integrations.Vue
      Sentry.init({
        dsn: 'https://258735d20d9c4988a9877ac3ec0facf4@trap.cekid.com/102',
        environment: BETA ? 'BETA' : 'production',
        integrations: [new VueIntegration({ Vue, attachProps: true })],
        release: '' // --sentry release--
      })
    })
  })
}
const { _debug } = getUrlAllParams(location.href) || {}
if (BETA || _debug) {
  //加入vconsole
  import('vconsole').then(v => {
    new v.default()
  })
}

import App from '@app/App.vue'
import '@plugins'
import '@styles/normalize.scss'
import router from './app/app-routing'
import { appStore as store } from './app/app.store'
Vue.config.productionTip = false
// import waterfall from 'vue-waterfall2'

// Vue.use(waterfall)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
